import axios from '../api/axios';

export async function getVehicleImages(vehicleId, options) {
  const res = await axios.get(`/vehicles/${vehicleId}/images`, options);

  return res.data;
}

export async function getVehicleImagesBrands(vehicleId, options) {
  const res = await axios.get(`/vehicles/${vehicleId}/imageBrands`, options);

  return res.data;
}

export async function transferVehicleImages(vehicleId, body) {
  const res = await axios.post(`/vehicles/${vehicleId}/images`, body, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
  return res.data;
}

export async function updateVehicleImage(vehicleId, imageId, body) {
  const res = await axios.patch(
    `/vehicles/${vehicleId}/images/${imageId}`,
    body,
    {
      headers: {
        'Content-Type': 'application/json',
      },
    }
  );
  return res.data;
}

export async function deleteVehicleImage(vehicleId, imageId) {
  const res = await axios.delete(`/vehicles/${vehicleId}/images/${imageId}`);

  return res.data;
}

export async function deleteVehicleImages(vehicleId) {
  const res = await axios.delete(`/vehicles/${vehicleId}/images`);

  return res.data;
}

export async function downloadImage(vehicleId, imageId) {
  const res = await axios.get(`/vehicles/${vehicleId}/images/${imageId}/download`, {
      responseType: 'blob',
    });

  return res.data;
}
